Vue.component('ack-world-extended-service-card-downloads', {
	delimiters: ['${', '}$'],
	template: '#ack-world-extended-service-card-downloads',
	mixins: [stringHelpersMixins],
	created() {
		appLog.log('ack-world-extended-service-card-downloads created');
		//fix for sw3257 not in master
	},
	computed: {
		...Vuex.mapGetters('localization', ['COUNTRY_SELECT']),

		countrySelectAsia() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'Asia');
		},
		countrySelectAfrica() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'Africa');
		},
		countrySelectEurope() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'Europe');
		},
		countrySelectCentralAmerica() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'Central America');
		},
		countrySelectSouthAmerica() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'South America');
		},
		countrySelectOceania() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'Oceania');
		},
		countrySelectNorthAmerica() {
			return this.COUNTRY_SELECT.filter((m) => m.continent === 'North America');
		},
		countrySelectOthers() {
			return this.COUNTRY_SELECT.filter(
				(m) =>
					m.continent !== 'North America' &&
					m.continent !== 'Oceania' &&
					m.continent !== 'South America' &&
					m.continent !== 'Central America' &&
					m.continent !== 'Europe' &&
					m.continent !== 'Africa' &&
					m.continent !== 'Asia',
			);
		},

		arrayContinents() {
			let array = [];
			array.push({ continent: 'Africa', countries: this.countrySelectAfrica });
			array.push({ continent: 'Asia', countries: this.countrySelectAsia });
			array.push({ continent: 'Central America', countries: this.countrySelectCentralAmerica });
			array.push({ continent: 'Europe', countries: this.countrySelectEurope });
			array.push({ continent: 'North America', countries: this.countrySelectNorthAmerica });
			array.push({ continent: 'Oceania', countries: this.countrySelectOceania });
			array.push({ continent: 'South America', countries: this.countrySelectSouthAmerica });
			//array.push({continent: 'Others', countries: this.countrySelectOthers})
			return array;
		},
	},
	data() {
		return {
			pageId: 'world-extended-service-card-downloads',
			pdfDatas: [
				{
					region: 'Africa',
					countries: {
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ROW_Concierge+World+%26+Standard+Warranty+Extensions_Digital.pdf',
						},
					},
				},
				{
					region: 'Asia',
					countries: {
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ROW_Concierge+World+%26+Standard+Warranty+Extensions_Digital.pdf',
						},
					},
				},
				{
					region: 'Central America',
					countries: {
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/LATAM_Concierge+Service+Extension_Digital.pdf',
						},
					},
				},
				{
					region: 'Europe',
					countries: {
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/Eurozone_Concierge+Service+%26+World+Extensions_Digital.pdf',
						},
					},
				},
				{
					region: 'North America',
					countries: {
						'United States': {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/US_CA_Concierge+Service+Extension_Digital.pdf',
						},
						Canada: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/US_CA_Concierge+Service+Extension_Digital.pdf',
						},
						Mexico: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ROW_Concierge+World+%26+Standard+Warranty+Extensions_Digital.pdf',
						},
						rest_countries_of_the_region: {
							pdf_link: '',
						},
					},
				},
				{
					region: 'Oceania',
					countries: {
						Australia: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ANZ_INDIA_Concierge+Service+Extension_Digital.pdf',
						},
						'New Zealand': {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ANZ_INDIA_Concierge+Service+Extension_Digital.pdf',
						},
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/ROW_Concierge+World+%26+Standard+Warranty+Extensions_Digital.pdf',
						},
					},
				},
				{
					region: 'South America',
					countries: {
						rest_countries_of_the_region: {
							pdf_link:
								'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/extedned-service/LATAM_Concierge+Service+Extension_Digital.pdf',
						},
					},
				},
			],
		};
	},
	methods: {
		findPdfUrl(selectedRegion, selectedCountry) {
			let selectedPdfLink = '';

			for (pdfData of this.pdfDatas) {
				if (pdfData.region === selectedRegion) {
					const keyToBeUse = pdfData.countries[selectedCountry]
						? selectedCountry
						: 'rest_countries_of_the_region';
					selectedPdfLink = pdfData.countries[keyToBeUse].pdf_link;
				}
			}
			return selectedPdfLink;
		},
		onCountryClick(selectedRegion, selectedCountry) {
			let pdfUrl = this.findPdfUrl(selectedRegion, selectedCountry);
			window.open(pdfUrl, '_blank');
		},
	},
});
